import React from 'react';
import PropTypes from 'prop-types';

import MuiCard from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';

import { convertToMuiPaperProps, PAPER_VARIANTS } from './Paper';

const styles = () => ({
  root: {},
});

function Card({
  elevation,
  variant,
  ...rest
}) {
  return (
    <MuiCard
      {...rest}
      {...convertToMuiPaperProps({ variant, elevation })}
    />
  );
}

Card.defaultProps = {
  elevation: null,
  variant: 'tight',
};

Card.propTypes = {
  elevation: PropTypes.number,
  variant: PropTypes.oneOf(PAPER_VARIANTS),
};

export default withStyles(styles)(Card);
